import React from "react";
import { PickProgressData } from "../../OrderOverview/OrderOverview";

import styles from "./index.module.css";
import classNames from "classnames";
import { Icon } from "semantic-ui-react";

type Props = {
  onClick: () => void;
};

const ProgressButton = ({ onClick }: Props) => {
  const classes = classNames(styles["progress-button"]);
  return (
    <button className={classes} onClick={onClick}>
      <Icon name="fast forward"></Icon>
    </button>
  );
};

export default ProgressButton;
